<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to Settings" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="settings" pageId="leave-types" color="white"></help-link> 
                    <v-btn v-if="hasEditRights" fab dark small color="primary" title="Add New Leave Type" @click="showAdd">
                        <v-icon dark>add</v-icon>
                    </v-btn>
                </v-toolbar>
            </v-card>
            <v-alert v-if="error" :value="true" color="error" icon="error" outline style="margin:10px 0px 10px 0px;">
                Error encountered. Please contact support. Error details: {{errorMessage}}
            </v-alert>  
            <v-card class="elavation-1" style="margin-top:5px;"> 
                <v-toolbar flat height="45px">
                    Leave Types
                    <v-spacer></v-spacer>
                    <span class="caption">
                        <v-switch
                            v-model="userDefined"
                            label="User Defined"
                            color="primary"
                            style="margin-top:15px;"
                        ></v-switch> 
                    </span>
                </v-toolbar>
                <v-data-table
                    :headers="headers"
                    :items="leave_types_filtered"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync"
                >
                <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                    <template v-slot:items="props">
                        <tr v-if="props.item.created.userId==0" title="System generated. Not editable.">
                            <td>{{ props.item.leaveCode }}</td>
                            <td>{{ props.item.leaveName }}</td>
                            <td>{{ props.item.leaveDescription }}</td>
                            <td>{{ props.item.created.createdOn|moment('YYYY-MM-DD') }}</td>
                            <td>System Generated</td>
                        </tr>
                        <tr v-else @click="viewEdit(props.item)" title="Click to Edit" style="cursor:pointer;">
                            <td>{{ props.item.leaveCode }}</td>
                            <td>{{ props.item.leaveName }}</td>
                            <td>{{ props.item.leaveDescription }}</td>
                            <td>{{ props.item.created.createdOn|moment('YYYY-MM-DD') }}</td>
                            <td>
                                <v-chip style="margin-left:-3px;">
                                    <v-avatar>
                                        <v-img :src="awsS3Helper.getAvatarUrl(props.item.created.userId)"></v-img>
                                    </v-avatar>
                                    <b>{{props.item.created.firstName}} {{props.item.created.lastName}}</b>
                                </v-chip>
                            </td>
                        </tr>
                    </template>
                </v-data-table> 
            </v-card>

            <!-- Comments and Updates -->
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <!-- comments history component -->
                    <comments-history v-if="!loading" :comments_data="commentsData"></comments-history>
                </v-flex>
                <v-flex xs12 sm6>
                    <update-history v-if="!loading" ref="updateHistoryRef" :page_query_id="pageQueryId"></update-history>
                </v-flex>
            </v-layout>
        </v-flex>

        <v-dialog v-model="dialogAddEdit" persistent width="500">
            <addedit-leavetype ref="addEditLeaveTypeRef" :dialogAddEdit.sync="dialogAddEdit" @send="getLeaveTypes"></addedit-leavetype>
        </v-dialog>

        <!-- status messaging component -->
        <status-messaging :page_query_id="pageQueryId" @refresh="updateHandler"></status-messaging>
    </v-layout>  
</template>
<script>

import leaveTypesApi from '@/api/leavetypes'
import commonfn from '@/common/functions'
import pageKeys from '@/common/pagekeys'
import notificationTypes from '@/common/notificationTypes'
import awsS3Helper from '@/helpers/aws-s3'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'

export default { 
    name: 'LeaveTypes',
    metaInfo: {
        title: 'LeaveTypes',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View and create Leave Types' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },    
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'addedit-leavetype' : () => import('@/components/LeaveTypes/AddEditLeaveType'),
        'status-messaging': () => import('@/components/Common/StatusMessaging'),
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory')
    },   
    data () {
        const routeName = this.$route.name
        const savedSort = userPrefs.getSort(routeName)

        return {
            commonfn,
            awsS3Helper,
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            error: false,
            errorMessage: '',
            loading: false,
            disabled: false,
            userDefined: false,
            dialogAddEdit: false,
            mode: '',
            headers: [
                {text:'Code', align: 'left', value:'leaveCode', width: '10%', sortable:true},
                {text:'Name', align: 'left', value:'leaveName', width: '20%', sortable:true},
                {text:'Description', align: 'left',value: 'leaveDescription', width: '25%', sortable:true},
                {text:'Created On', align: 'left',value: 'createdOn', width: '20%', sortable:true},
                {text:'Created By', align: 'left',value: '', width: '25%', sortable:false},
            ],
            leave_types: []
        }
    },
    methods: {   
        updateHandler(data) {
            if (data!=this.$store.state.userId) {
                this.getLeaveTypes(false)
            }
            //invoke updateHistoryRef appendData 
            this.$refs.updateHistoryRef.getHistory()
        },     
        viewEdit(data) {
            if (this.hasEditRights) {
                this.$refs.addEditLeaveTypeRef.setParamsEdit(data)
                this.dialogAddEdit = true
            }
        },
        showAdd() {
            this.$refs.addEditLeaveTypeRef.setParamsAdd()
            this.dialogAddEdit = true
        },  
        async getLeaveTypes(show_loading) {
            try{
                this.loading = show_loading
                const response = await leaveTypesApi.getByCompany()
                if (response&&response.status==200){
                    this.leave_types=response.data.items
                }
                this.loading = false
            }
            catch(error){
                this.error = true
                this.errorMessage = error
            }
        }
    },
    created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Leave Types'
        })

        this.getLeaveTypes(true)
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            userPrefs.updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            userPrefs.updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        }
    },
    computed: {
        hasEditRights() {
            return commonfn.hasEditRights(this.$router.currentRoute.path)
        },
        isMobile() {
            return window.innerWidth < 600
        },
        companyIdStr() {
            return this.$store.state.companyId
        },
        pageQueryId() {
            return `${this.companyIdStr}_leavetypes`
        },
        commentsData() {
            if (!this.loading) {
                return {
                    pageQueryId: this.pageQueryId,
                    pageItemCreatedBy: null,
                    pageLink: this.$router.currentRoute.path,
                    pageKey: pageKeys.leave_types,
                    notificationTypeId: notificationTypes.leave_types
                }
            }
        },
        leave_types_filtered() {
            var temp = this.leave_types

            //search handler
            if (this.userDefined) {
                temp = temp.filter(item => item.created.userId != 0)
            }
            return temp
        }
    }
  }
</script>